var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M9.334 19.167a8 8 0 0 0-4 8 8 8 0 0 0 8-4m-8-5.334a10.666 10.666 0 0 1 9.333 9.334 8 8 0 0 0 4-6.667 12 12 0 0 0 8-10.667 4 4 0 0 0-4-4 12 12 0 0 0-10.667 8 8 8 0 0 0-6.666 4ZM18.667 12.5a1.333 1.333 0 1 0 2.667 0 1.333 1.333 0 0 0-2.667 0Z","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})
}
var staticRenderFns = []

export { render, staticRenderFns }